import { DEVELOPMENT } from 'src/config-global';

/**
 * Model tiers. The engine routes every user request through a cheap classifier
 * and then picks the tier that matches the difficulty of the task.
 * Adjust the models here.
 */
export const AI_MODELS = {
  light: 'gpt-4.1-nano',
  standard: 'gpt-4.1-mini',
  advanced: 'gpt-4.1',
} as const;

export type ModelTier = keyof typeof AI_MODELS;

/** Hard cap on LLM round-trips within a single user turn. */
export const MAX_AGENT_ITERATIONS = 12;

/** Tool results larger than this are truncated before being sent to the LLM. */
export const MAX_TOOL_RESULT_CHARS = 14000;

/** Oldest messages are dropped beyond this limit to keep the context window lean. */
export const MAX_HISTORY_MESSAGES = 40;

export const CONTEXT_WINDOW_TOKENS = 128_000;

export const LLM_TEMPERATURE = 0.2;

export const AI_REPORT_MODEL = AI_MODELS.advanced;

export const AI_REPORT_TEMPERATURE = 0.3;

/** "Fix with AI" writes student-facing material, so it always runs on the strongest tier. */
export const AI_FIX_MODEL = AI_MODELS.advanced;

export const AI_FIX_TEMPERATURE = 0.3;

/** Per-fix budgets: stated in the prompt and enforced again when the proposal is validated. */
export const AI_FIX_LIMITS = {
  textBlocks: 3,
  practiceBlocks: 2,
  practiceQuestions: 5,
  /** Lecture content serialized into the prompt — per text block and for the whole lecture. */
  blockChars: 6000,
  contentChars: 60000,
} as const;

export const AI_PRIVACY_ENABLED = DEVELOPMENT;
